// extracted by mini-css-extract-plugin
export default {"card":"yaMQ0hGT8LF_o62Qzwz2"};